import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const loadExplosionSnippet = `
    this.load.spritesheet("explosion", "explosion.png", {
      frameWidth: 260,
      frameHeight: 260
    });
`

const explosionAnimSnippet = `
    var explosionAnimConfig = {
      key: "explosionAnimation",
      frames: this.anims.generateFrameNumbers("explosion", {
        start: 0,
        end: 5,
        first: 0
      }),
      frameRate: 10,
      repeat: 0
    };

    this.anims.create(explosionAnimConfig);
`

const collisinBulletSnippet = `
    this.physics.add.overlap(
      this.playerBullets,
      this.enemies,
      this.bulletHitEnemy,
      null,
      this
    );
`

const bulletHitEnemySnippet = `
  bulletHitEnemy(bullet, enemy) {
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!bullet.active) {
      return;
    }
    bullet.disableBody(true, true);
    bullet.x = -100;

    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
`

const fireFunctionUpdateSnippet = `
  fire(dt) {
    this.nextFireTime -= dt;
    if (this.nextFireTime > 0) {
      return;
    }
    const bullet = this.playerBullets.getFirstDead();
    if (bullet === undefined || bullet == null) {
      return;
    }

    bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
    bullet.setScale(0.2);
    bullet.body.velocity.x += 300;
    this.nextFireTime = this.fireRate;
  }
`

const CollisionDetection = () => (
  <>
    <h1>Collision Detection</h1>
    <p>
      Now that the planes are flying around you probably noticed if you shoot a
      enemy or if the enemy run into you nothing happens. Thats because we need
      to add some collision detection. First lets load in a new explosion sprite
      sheet so our enemy planes will explode when we shoot them. Inside the
      preload function add the following code:
    </p>
    <CopyBlock
      text={loadExplosionSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we need to add a few things to our create function, we will start with
      setting up the explosion animation:{" "}
    </p>
    <CopyBlock
      text={explosionAnimSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now we need to set up some detection for our bullets and our enemies, add
      this to the bottom of the create function:{" "}
    </p>
    <CopyBlock
      text={collisinBulletSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      What we are saying here is when a bullet touches an enemy, call the
      bulletHitEnemy function. Which we need to create, so copy this function
      and add it near your other functions:{" "}
    </p>
    <CopyBlock
      text={bulletHitEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      You should now be able to shoot and blow up enemy planes. You may have
      noticed that our bullets are behaving strange. Replace the fire function
      with the following code:{" "}
    </p>
    <CopyBlock
      text={fireFunctionUpdateSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>Now our bullets should be behaving more as expected.</p>
    <br />
    <br />
    <Button type="button" variant="secondary" href="/KeepingScore">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default CollisionDetection
